(function AdzukiProofOfPurchase($, Adzuki)
{
	const component = {
		emits : ['submitted-form', 'cancel'],
		inject: {
			openToast: {
				default: () => undefined
			},
			openAlert: {
				default: () => undefined
			},
			fileNameFromPath: {
				default: () => undefined
			}
		},
		props: {
			popData: {
				type: Object,
			},
			mediaId: {
				type: String,
			},
			chosenFile: {
				type: Object,
			},
			sectionInfo: {
				type: Object,
			},
			// shows a Cancel link next to Submit (the picker drawer, MEDIA-286)
			cancelable: {
				type   : Boolean,
				default: false,
			}
		},
		data() {
			return {
				popForm: {
					siteAcquired  : '',
					proofOwnership: null,
					notes         : ''
				},
				errors: {},
			};
		},
		template: `
			<div class="pop-form-container row p-3">
				<div class="col-12">
					<h4>Additional Approval Needed</h4>
					<p>This image must be submitted for approval and/or was found to be used on other websites, with or without being generated from AI.</p>
					<p>This image currently has limited approval for use within CP Maxx tools only. Please fill out the form below to submit this image for review and approval by Home Office to gain unlimited approval within CP Maxx and Website Admin tools.</p>
				</div>
				<div class="col-12">
				<div class="form-group my-2">
					<label class="form-label" for="siteAcquired">
						Source 
						<span class="text-primary" data-toggle="tooltip" data-placement="top" title="Examples could include a ‘stock’ image website or another website from which your image was obtained. If these do not apply, you may enter N/A supplemented with Notes in the field shown below.">
							<i class="fas fa-question-circle"></i>
						</span>
					</label>
					<input class="form-control" type="url" name="siteAcquired" v-model="popForm.siteAcquired"/>
				</div>
				<div class="form-group my-2">
				  <label for="mediaId">Proof of Ownership <span class="text-primary" data-toggle="tooltip" data-placement="top" title="Upload any documentation to prove ownership of the image (e.g. Receipts, Invoices, etc.)"><i class="fas fa-question-circle"></i></span></label>
				  <input class="form-control" type="file" name="proofOwnership" @change="onProofChange"/>
				</div>
				<div v-if="popData.proof_path">
					<p>{{ fileNameFromPath(popData.proof_path) }}</p>
				</div>
				<div class="form-group my-2">
				  <label for="media_id">Notes</label>
				  <textarea class="form-control" rows="3" name="notes" v-model="popForm.notes"></textarea>
				</div>
				<div class="form-group my-2">
				  <button type="button" class="btn btn-primary mt-3" @click="submitPopForm">Submit for Approval</button>
				  <button v-if="cancelable" type="button" class="btn btn-link mt-3 ms-2" @click="$emit('cancel')">Cancel</button>
				</div>
				</div>
			</div>
		`,
		computed: {
		},
		methods: {
			onProofChange(e) {
				const files = e.target.files;
				this.popForm.proofOwnership = files && files.length ? files[0] : null;
			},
			submitPopForm() {
				if (!this.validateForm()) {
					this.openAlert('error', 'Error', this.errors.name);
					return;
				}

				const proofOfPurchase = new FormData();

				if (this.popData.length > 0) {
					proofOfPurchase.append('id', this.popData.id);
				}

				proofOfPurchase.append('media_id', this.mediaId);
				proofOfPurchase.append('section_id', this.sectionInfo.id || null);
				proofOfPurchase.append('site_acquired', this.popForm.siteAcquired);
				proofOfPurchase.append('proofOwnership', this.popForm.proofOwnership);
				proofOfPurchase.append('notes', this.popForm.notes);

				fetch(this.$baseUri + '/Media/savePopForm/', {
					method: 'POST',
					body  : proofOfPurchase,
				})
					.then(response => response.json())
					.then(data => {
						if (data.status === 'success') {
							this.openAlert('success', 'Success', 'Form successfully submitted for Home Office review.');
							this.popForm = {};
							this.$emit('submitted-form', this.chosenFile);
						}
					})
					.catch(error => {
						this.openAlert('error', 'Error', error);
					});
			},
			validateForm() {
				this.errors = {};

				const hasSite = this.popForm.siteAcquired !== null && this.popForm.siteAcquired.trim() !== '';

				if (!hasSite) {
					this.errors.name = 'At minimum, please enter the website from which you acquired this media.';
				}

				return Object.keys(this.errors).length === 0;
			},
		},
		watch: {
			popData: {
				immediate: true,
				deep     : false,
				handler(newVal) {
					if (!newVal) {
						return;
					}

					this.popForm.siteAcquired = newVal.site_acquired ?? newVal.siteAcquired ?? '';
					this.popForm.notes = newVal.notes ?? '';
				}
			}
		}
	};

	Adzuki.VueComponents.AdzukiProofOfPurchase = component;
}(jQuery, window.Adzuki || {}));
